<template>
    <v-menu ref="menuTime" v-model="isTimePickerVisible" :close-on-content-click="false" transition="scale-transition"
        offset-y :open-on-click="false">
        <template v-slot:activator="{ on }">
            <v-text-field v-model="hrBase" :rules="rules" :label="label" v-on="on" outlined @click:append="showPicker"
                append-icon="mdi-clock" return-masked-value v-mask="mask" clearable>
            </v-text-field>
        </template>
        <v-time-picker color="info" :full-width="isMobile" :landscape="!isMobile" v-if="isTimePickerVisible" format="24hr" 
            v-model="hrPicker" @input="isDatePickerVisible = false">
        </v-time-picker>
    </v-menu>
</template>

<script>
import { mask } from 'vue-the-mask'

export default {
    props: {
        label: String,
        rules: Array,
        value: String
    },
    directives: {
        mask,
    },
    model: {
        props: "value",
        event: "input"
    },
    data() {
        return {
            isTimePickerVisible: false,
            hrPicker: null,
            mask: '##:##'
        }
    },
    computed: {
        hrBase: {
            get(){
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        },
        isMobile() {
            return this.$vuetify.breakpoint.xs
        },
    },
    methods: {
        showPicker() {
            if (this.hrBase)
            {
                if(this.hrBase.length == 5){
                    this.hrPicker = this.hrBase
                } else {
                    this.hrPicker = null
                }
            }
            this.isTimePickerVisible = true
        }
    }, 
    watch: {
        hrPicker(newVal) {
            this.hrBase = newVal
        }
    }
}
</script>